"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const lib_1 = require("@brandfree-front/lib");
const GaButton_1 = __importDefault(require("../../util/GaButton"));
const GDPRChoice_1 = __importDefault(require("./GDPRChoice"));
const marketing_channels_1 = require("../../config/marketing-channels");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const StoresUtil_1 = require("../../util/StoresUtil");
const crm_components_1 = require("crm-components");
let GDPRChoicesB2BMarketing = class GDPRChoicesB2BMarketing extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "marketingChannelsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "locationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onConfirm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                await this.marketingChannelsStore.saveDirectMarketing();
                if (!this.marketingChannelsStore.areChannelsErroneous) {
                    (0, crm_components_1.navigate)('/success');
                }
            }
        });
        Object.defineProperty(this, "onCancel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.locationStore.redirectUrl ? window.location.replace(this.locationStore.redirectUrl) : this.ssoStore.doLogout();
            }
        });
    }
    render() {
        const { translate } = this.translateStore;
        if (this.marketingChannelsStore.isLoading) {
            return react_1.default.createElement(lib_1.Spinner, null);
        }
        return (react_1.default.createElement(lib_1.Grid, { align: ['center-xs'] },
            react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'md-10', 'lg-8'] },
                react_1.default.createElement(lib_1.Text, { className: "text-center" },
                    react_1.default.createElement(lib_1.Heading, { className: "text-primary h2" }, translate('gdpr.choice.b2b.marketing.title')),
                    react_1.default.createElement(lib_1.Separator, { weight: "thin", color: "invisible", spacing: "xsmall" }),
                    react_1.default.createElement(lib_1.Grid, { align: ['center-xs'], className: "text-left" },
                        react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'md-10'] },
                            react_1.default.createElement(lib_1.Separator, { weight: "thin", color: "medium" }),
                            react_1.default.createElement(lib_1.Card, { background: "transparent" },
                                react_1.default.createElement(lib_1.CardContent, null,
                                    react_1.default.createElement(GDPRChoice_1.default, { id: "gdpr-b2b-marketing", text: translate('gdpr.choice.b2b.marketing.main'), description: this.getMarketingContent(), checked: this.marketingChannelsStore.getSmsChannelValue || this.marketingChannelsStore.getEmailChannelValue, onChange: (value) => {
                                            this.marketingChannelsStore.findAndUpdateMarketingChannelValue(marketing_channels_1.MarketingChannelType.EMAIL, value);
                                            this.marketingChannelsStore.findAndUpdateMarketingChannelValue(marketing_channels_1.MarketingChannelType.SMS, value);
                                        }, onDetailsClick: () => (0, crm_components_1.navigate)('/turunduspakkumised-info') })),
                                react_1.default.createElement(lib_1.Separator, { weight: "thin", color: "medium" })))),
                    react_1.default.createElement(lib_1.Separator, { spacing: "xsmall", color: "invisible" }),
                    react_1.default.createElement(lib_1.Grid, { align: ['center-xs', 'middle-xs'] },
                        react_1.default.createElement(lib_1.GridColumn, { width: ['xs'] },
                            react_1.default.createElement(GaButton_1.default, { id: "gdpr-choices-b2b-marketing-cancel", text: translate('gdpr.cancelButton'), link: true, onClick: this.onCancel })),
                        react_1.default.createElement(lib_1.GridColumn, { width: ['xs'] }, this.marketingChannelsStore.isLoading ? (react_1.default.createElement(lib_1.Spinner, null)) : (react_1.default.createElement(GaButton_1.default, { id: "gdpr-choices-b2b-marketing-confirm", text: translate('gdpr.choices.confirm'), onClick: this.onConfirm, isLoading: this.marketingChannelsStore.isLoading }))))))));
    }
    getMarketingContent() {
        const { translate } = this.translateStore;
        const channels = [];
        if (this.marketingChannelsStore.getEmailChannelValue) {
            channels.push('gdpr-email');
        }
        if (this.marketingChannelsStore.getSmsChannelValue) {
            channels.push('gdpr-sms');
        }
        return (react_1.default.createElement(lib_1.Text, null,
            react_1.default.createElement(lib_1.ChoiceGroup, { id: "gdpr-channels", label: "Sidevahend", hideLabel: true, type: "check", options: [
                    {
                        id: 'gdpr-email',
                        value: 'gdpr-email',
                        labelText: translate('gdpr.channels.email')
                    },
                    {
                        id: 'gdpr-sms',
                        value: 'gdpr-sms',
                        labelText: translate('gdpr.channels.sms')
                    }
                ], value: channels, onChange: (newValue) => {
                    this.marketingChannelsStore.findAndUpdateMarketingChannelValue(marketing_channels_1.MarketingChannelType.EMAIL, newValue.includes('gdpr-email'));
                    this.marketingChannelsStore.findAndUpdateMarketingChannelValue(marketing_channels_1.MarketingChannelType.SMS, newValue.includes('gdpr-sms'));
                    if (!this.marketingChannelsStore.marketingOffersAllowed && newValue.length !== 0) {
                        this.marketingChannelsStore.changeDirectMarketing(true);
                    }
                } }),
            react_1.default.createElement("p", { className: "text-tiny text-color-normal" }, translate('gdpr.choice.b2b.marketing.description'))));
    }
};
__decorate([
    mobx_1.action
], GDPRChoicesB2BMarketing.prototype, "getMarketingContent", null);
GDPRChoicesB2BMarketing = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], GDPRChoicesB2BMarketing);
exports.default = GDPRChoicesB2BMarketing;
